import { Container, Typography, Link, Toolbar } from '@mui/material';
import React from 'react';
import { useAuth } from './hooks';
import * as AuthStore from './store/Auth';
import { useAppDispatch } from './store';

export const Unauthorized = () => {
	const acct = useAuth();
	const dispatch = useAppDispatch();

	function handleLogout() {
		dispatch(AuthStore.actionCreators.logout());
	}

	return (
		<Container maxWidth='md' style={{ textAlign: 'center' }}>
			<Toolbar />
			<Typography variant='subtitle2'>You are not authorized to use this application.</Typography>
			<Typography variant='subtitle2'>
				If you believe this is an error, please contact <Link href='mailto: helpdesk@empire-today.com'>Helpdesk</Link>
			</Typography>

			<br />
			{acct && acct.currentAccount && (
				<Typography variant='subtitle2'>
					You are currently signed in as {acct.currentAccount.username}.{' '}
					<Link href='#' onClick={handleLogout}>
						Sign Out
					</Link>
				</Typography>
			)}
		</Container>
	);
};
